import type * as React from 'react';
import { put } from '@Domain/Api';
import assignmentScopePath from '@Application/Ai/AiConfiguration/Assignments/assignmentScopePath';
import modelAssignmentSaved, {
	type ModelAssignmentSavedAction,
	type ModelAssignmentSavedPayload,
} from '@Application/Ai/AiConfiguration/Assignments/Actions/modelAssignmentSaved';
import modelAssignmentSaveFailed, {
	type ModelAssignmentSaveFailedAction,
} from '@Application/Ai/AiConfiguration/Assignments/Actions/modelAssignmentSaveFailed';
import type SaveModelAssignment from '@Application/Ai/AiConfiguration/Assignments/Commands/SaveModelAssignment';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../../parameters';

type Actions = ModelAssignmentSavedAction | ModelAssignmentSaveFailedAction;

export default (command: SaveModelAssignment) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await put<ModelAssignmentSavedPayload>(
				`${parameters.api.host}/api/${assignmentScopePath(command.scope)}/${command.usage}`,
				command.toJSON(),
			);

			const action = modelAssignmentSaved(payload, command.scope);
			dispatch(action);
			return action;
		} catch (error) {
			const action = modelAssignmentSaveFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
